// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2xNBH","content":"styles_content__3HeUU","tableWrap":"styles_tableWrap__paPww"};